export * from "-!../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./registration-by-phone.vue?vue&type=template&id=5f85e1ec"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/quick-login-reg/registration-by-phone.vue?vue&type=template&id=5f85e1ec
// module id = 6TPR
// module chunks = 0